<template>
  <ModalBase
    :show-modal="true"
    @close-modal="close"
    :loading="false"
    auto-h
    width-md
    :narrow="true"
    :overlay-scrollb="true"
    class="referral-info-modal dashboard-modal"
  >
    <template v-slot:maincontent>
      <h1>{{ mainTitle }}</h1>

      <div class="referral-modal-body">
        <div>
          <div class="referral-modal-body__title">
            <span v-if="messageType === 'basic'">{{ titles.basic }}</span>
            <span v-else-if="messageType === 'monthly'">{{ titles.monthly }}</span>
            <span v-else>{{ titles.referral }}</span>
          </div>

          <div v-if="messageType === 'basic'">
            <p class="referral-modal-text">{{ messages.basicIntro }}</p>
            <p class="referral-modal-text">{{ messages.basicEligible }}</p>
          </div>

          <div v-else-if="messageType === 'monthly'">
            <p class="referral-modal-text">{{ messages.monthlyIntro }}</p>
          </div>

          <div v-else class="referral-modal-section--success">
            <p class="referral-modal-text referral-modal-text--success">{{ messages.alreadyActive }}</p>
          </div>
        </div>

        <div>
          <div class="discount-badge">
            <span class="discount-amount">30<span>%</span></span>
            <span>{{ messages.badgeLabel }}</span>
          </div>
        </div>
      </div>
      <div v-if="messageType === 'basic'" class="referral-modal-cta">
        <GekkoButton
          :href="Urls['subscriptions:manage']()"
          :text="messages.basicCtaLabel"
          variant="primary"
          size="lg"
        />
      </div>
      <div v-else-if="messageType === 'monthly'" class="referral-modal-cta">
        <GekkoButton
          :href="Urls['subscriptions:manage']()"
          :text="messages.monthlyCtaLabel"
          variant="primary"
          size="lg"
        />
      </div>
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import GekkoButton from '@/components/GekkoButton'
import ModalBase from '@/components/base_components/ModalBase'

export default {
  name: 'ReferralInfoModal',
  components: { ModalBase, TitleBar, GekkoButton },
  props: {
    messageType: {
      type: String,
      default: () => 'basic',
    },
  },
  data() {
    return {
      mainTitle: this.$gettext('Discount available!'),
      titles: {
        basic: this.$gettext('Upgrade and save with your exclusive discount'),
        monthly: this.$gettext('Switch to yearly and start saving today'),
        referral: this.$gettext('You are eligible for a referral discount!'),
      },
      messages: {
        badgeLabel: this.$gettext('off yearly Premium'),
        basicIntro: this.$gettext(
          'You currently have a Gekko Basic account. Upgrading to Premium gives you access to AI-powered expense scanning, custom invoice design, and direct bank account integration.'
        ),
        basicEligible: this.$gettext(
          'Because you are my client, you are eligible for a 30% discount on a yearly Premium subscription — every single year.'
        ),
        monthlyIntro: this.$gettext(
          'You are on Gekko Premium — great choice! Did you know that as my client you qualify for a 30% discount on a yearly subscription? Switching saves you over €40 every year.'
        ),
        alreadyActive: this.$gettext('You already have access to a 30% discount on a yearly Premium subscription.'),
        basicCtaLabel: this.$gettext('Upgrade and save 30%'),
        monthlyCtaLabel: this.$gettext('Switch to yearly and save'),
      },
    }
  },
  destroyed() {
    window.removeEventListener('keydown', this.closeEventListener)
  },
  methods: {
    closeEventListener(event) {
      if (event.key === 'Escape') this.close()
    },
    close() {
      this.$emit('close-modal', false)
    },
  },
}
</script>

<style lang="scss">
.referral-info-modal.dashboard-modal {
  .modal-content-wrap {
    background: linear-gradient(-7deg, #ffffff 0%, #ffffff 50%, #22ac8a 50%, #22ac8a 100%);
    border-radius: 12px !important;
  }
  h1 {
    color: white;
    margin-bottom: 1rem;
  }
  @media (min-width: 768px) {
    .os-content {
      padding: 2rem !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.referral-modal-body {
  position: relative;
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: white;
  border: 1px solid $colorBorderDash;
  border-radius: $radiusMd;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

  &__title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: $fontMedium;
    font-size: 18px !important;
    padding-bottom: 0.75rem;
  }

  .discount-badge {
    padding: 1rem;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100px;
    height: 100px;
    border: 3px dashed white;
    box-shadow: 0 0 0 2px #c42f52, rgba(0, 0, 0, 0.2) 0px 15px 35px 0px, rgba(0, 0, 0, 0.12) 0px 5px 15px 0px;
    background: #c42f52;
    color: white;
    border-radius: 100%;
    font-size: 18px;
    line-height: 1.2;
    zoom: 0.9;
    transform: rotate(10deg);
    transition: transform 0.2s ease;

    .discount-amount {
      font-family: 'Campton-Bold';
      text-align: center;
      font-size: 22px;
      line-height: 1;
      span {
        font-size: 16px;
        text-align: center;
      }
    }

    @media (min-width: 768px) {
      width: 150px;
      height: 150px;
      font-size: 20px;
      text-align: center;

      .discount-amount {
        font-size: 38px;
        span {
          font-size: 18px;
        }
      }
    }
  }

  .referral-modal-text {
    font-size: 15px;
    color: $colorTextBase;
    line-height: 1.6;
    margin-bottom: 0;

    &--success {
      display: flex;
      align-items: center;
      justify-content: center;
      color: $colorBrand;
      background: $colorBrand50;
      border: 1px solid $colorBrand200;
      border-radius: $radiusMd;
      padding: 1rem 1.25rem;
      font-family: $fontMedium;
    }
  }
}

.referral-modal-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  text-align: center;
}
</style>
